// 定期公告
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
    <div class="box">

        <div class="dropdown">
            <el-dropdown @command='handleSelectName' placement="left-start">
            <span class="el-dropdown-link">
                {{selectup + '年'}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div>
                <el-dropdown-menu slot="dropdown" trigger='click'>
                        <div class="drop_menu">
                            <div v-for="(list,i) in select">
                            <!-- command绑定i来判断是哪一个下拉 -->
                            <el-dropdown-item :command=i>
                                {{list + '年'}}
                            </el-dropdown-item>
                        </div>
                        </div>
                </el-dropdown-menu>
            </div>
</el-dropdown>
        </div>
    <div>
  <el-table v-el-table-infinite-scroll="load" height="51.4375rem"
   :data="tableData" stripe class="table" @cell-click="handle">
    <el-table-column prop="title" label="标题"></el-table-column>
    <el-table-column prop="a_types" align="right" label="类型" ></el-table-column>
    <el-table-column prop="publish_date"  :label="this.selectup + '年'" align="right"></el-table-column>
    <!-- <div slot="append" style="text-align: center;margin-top:.925rem" @click="load"> -->
    <!--在此处添加你想要插入在表格最后一行的内容-->
    <!-- <p v-if="this.count<=this.page_count">加载更多...</p>
    <p v-else>没有更多了</p>
    </div> -->
  </el-table>
    </div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import elTableInfiniteScroll from 'el-table-infinite-scroll';

import api from '@/utils/api'
export default {
  name: 'Year',
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  data () {
    return {
      image: "",
      selectup: '',
      tableData: [],
      count: 1,
      page_count: 0,
      loading: false,
      list: [],
      select: [],
    }
  },
  computed: {
    disabled () {
      return this.loading || this.count >= this.page_count
    }
  },
  components: {
    // Header,
    Logo,
    Tabbar,
  },
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
    this.selectTime()
    this.getNotice()
  },
  methods: {
    // 下拉选项框
    selectTime () {
      var time = new Date().getFullYear()
      this.selectup = time
      var minTime = 2014
      for (let i = 0; i < time - minTime; i++) {
        this.select.push(time - i)
      }
    },
    load () {

      this.loading = true
      console.log('我是页面触底加载')
      console.log('count', this.count)
      if (this.count <= this.page_count) {
        this.getNotice()
        this.count++
      }
      this.loading = false

    },
    handle (row, column, cell, event) {
      // window.location.href=row.detail_url
      window.open(row.detail_url)
      console.log(row)
    },
    async getNotice () {
      const { data: data } = await api.getNotice(1, this.count, this.selectup)
      this.list = data.data.results
      console.log(data.data)
      this.list.forEach(item => {
        this.tableData.push(item)
      })
      this.page_count = data.data.page_count
    },
    handleSelectName (command) {
      this.selectup = this.select[command]
      this.tableData = []
      this.count = 1
      this.getNotice()
    }
  },
}
</script>
<style >
.el-dropdown-menu {
  left: auto !important;
  right: 0rem;
}
</style>
<style scoped>
/deep/ .el-dropdown-menu__item {
  color: #333333 !important;
  font-size: 1.75rem;
  margin-top: 1.5rem;
}
/* 选择菜单位置定义 */
/deep/ .drop_menu {
  margin-top: 1.75rem;
  margin-bottom: 2rem;
  text-align: left;
}
/* table的内部样式 */
/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  font-size: 1.5rem;
  color: #333333;
}
.dropdown {
  float: right;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #333333;
  font-size: 1.75rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.box {
  width: 43.875rem;
  height: 30.875rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 4.625rem;
}
/* 标题背景设置 */
/deep/ .el-table th.el-table__cell {
  background-color: #f5f5f5;
  border-bottom-color: #015aaa !important;
  color: #015aaa;
  font-size: 1.75rem;
}
/* 斑马条纹颜色 */
/deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f5f5f5;
}
/* 下拉菜单样式 */
.el-dropdown-link {
  cursor: pointer;
}
.el-dropdown {
  font-size: 1.75rem;
}
.el-icon-arrow-down {
  font-size: 1.75rem;
}
/* 表格样式 */
.table {
  /* display: flex */
}
.time {
  font-size: 1.375rem;
  color: #999999;
}
</style>